module.exports = __webpack_public_path__ + "img/beijing-3.ab32dae6.jpg";